<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 class="white--text">Voeg een nieuwe medewerker toe</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeNewEmployeeDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="pa-4 ma-0" v-if="feedback" :value="true" type="warning">{{
      feedback
    }}</v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="AddEmployeeForm" lazy-validation>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field
                label="Voornaam"
                v-model="newEmployee.firstName"
                prepend-inner-icon="person"
                required
                outlined
                hide-details
                :color="companyPrimaryColor"
                class="mt-4"
                :background-color="$vuetify.theme.themes[theme].menu"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md6>
              <v-text-field
                label="Achternaam"
                v-model="newEmployee.lastName"
                prepend-inner-icon="person"
                required
                outlined
                hide-details
                :color="companyPrimaryColor"
                class="mt-4"
                :background-color="$vuetify.theme.themes[theme].menu"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md6>
              <v-menu
                ref="birtdayDateDialog"
                :close-on-content-click="false"
                v-model="birtdayDateDialog"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    :value="birthdayDate.readable"
                    label="Geboortedatum"
                    prepend-inner-icon="cake"
                    readonly
                    outlined
                    hide-details
                    :color="companyPrimaryColor"
                    class="mt-4"
                    :background-color="$vuetify.theme.themes[theme].menu"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="birthdayDateRaw"
                  no-title
                  :max="today"
                  color="primary"
                  @input="birtdayDateDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-select
                :items="branches"
                item-text="branchName"
                item-value="id"
                prepend-inner-icon="location_on"
                v-model="newEmployee.branches"
                label="Vestigingen"
                outlined
                multiple
                hide-details
                :color="companyPrimaryColor"
                class="mt-4"
                :background-color="$vuetify.theme.themes[theme].menu"
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md6>
              <v-select
                :items="positions"
                item-text="name"
                item-value="id"
                prepend-inner-icon="assignment"
                v-model="newEmployee.position"
                label="Functie"
                outlined
                hide-details
                :color="companyPrimaryColor"
                class="mt-4"
                :background-color="$vuetify.theme.themes[theme].menu"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-menu
                :close-on-content-click="false"
                v-model="functionStartDateDialog"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    :value="functionStartDate.readable"
                    label="Startdatum functie"
                    prepend-inner-icon="today"
                    readonly
                    outlined
                    hide-details
                    :color="companyPrimaryColor"
                    class="mt-4"
                    :background-color="$vuetify.theme.themes[theme].menu"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="functionStartDateRaw"
                  no-title
                  color="primary"
                  @input="functionStartDateDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md6>
              <v-menu
                :close-on-content-click="false"
                v-model="functionEndDateDialog"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    :value="functionEndDate.readable"
                    label="Einddatum functie"
                    prepend-inner-icon="today"
                    readonly
                    outlined
                    hide-details
                    :color="companyPrimaryColor"
                    class="mt-4"
                    :background-color="$vuetify.theme.themes[theme].menu"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="functionEndDateRaw"
                  no-title
                  :min="today"
                  color="primary"
                  @input="functionEndDateDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeNewEmployeeDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="addEmployee()"
            >
              Medewerker toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import moment from "moment";

export default {
  name: "add-employee-comp-form",
  props: {
    activeCompData: Object,
    branches: Array,
    positions: Array,
  },

  data() {
    return {
      feedback: null,
      birtdayDateDialog: false,
      functionStartDateDialog: false,
      functionStartDateRaw: "",
      functionEndDateDialog: false,
      functionEndDateRaw: "",
      birthdayDateRaw: "",
      newEmployee: {
        firstName: null,
        lastName: null,
        revenue: null,
        position: null,
        branched: [],
      },
      today: null,
    };
  },

  created() {
    this.today = moment().format("YYYY-MM-DD");
  },

  watch: {
    birtdayDateDialog(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  methods: {
    closeNewEmployeeDialog() {
      this.$emit("newEmployeeDialogChange", false);
      this.newEmployee.name = null;
      this.newEmployee.revenue = null;
    },

    addEmployee() {
      if (
        this.newEmployee.firstName &&
        this.newEmployee.lastName &&
        this.newEmployee.position
      ) {
        let basicSchedule = {};
        this.newEmployee.branches.forEach((branch) => {
          basicSchedule[branch] = {};
          basicSchedule[branch].startDate = null;
          basicSchedule[branch].endDate = null;
          basicSchedule[branch].basicScheduleLastChanged = null;
          basicSchedule[branch].sun = [];
          basicSchedule[branch].mon = [];
          basicSchedule[branch].tue = [];
          basicSchedule[branch].wed = [];
          basicSchedule[branch].thu = [];
          basicSchedule[branch].fri = [];
          basicSchedule[branch].sat = [];
        });

        this.feedback = null;
        db.collection("employees")
          .add({
            firstName: this.newEmployee.firstName,
            lastName: this.newEmployee.lastName,
            position: this.newEmployee.position,
            branches: this.newEmployee.branches,
            basicSchedule: basicSchedule,
            birthdayDate: this.birthdayDate.firebase,
            startFunctionDate: this.functionStartDate.firebase,
            endFunctionDate: this.functionEndDate.firebase,
            companyId: this.activeCompData.id,
            deleted: {
              deleted: false,
            },
          })
          .then(() => {
            this.$emit("updateData");
            this.closeNewEmployeeDialog();
            this.$refs.AddEmployeeForm.reset();
          })
          .catch((error) => {
            console.error("Error adding position: ", error);
          });
      } else {
        this.feedback = "Vul alle velden in om een medewerker toe te voegen";
      }
    },
  },

  computed: {
    birthdayDate() {
      let date = {
        readable: "",
        formatted: "",
        firebase: null,
      };
      if (this.birthdayDateRaw) {
        date.readable = moment(this.birthdayDateRaw).format("D-M-YYYY");
        date.formatted = moment(this.birthdayDateRaw).format("YYYY/MM/DD");
        date.firebase = new Date(
          moment(this.birthdayDateRaw).format("YYYY/MM/DD"),
        );
        return date;
      } else {
        return date;
      }
    },
    functionStartDate() {
      let date = {
        readable: "",
        formatted: "",
        firebase: null,
      };
      if (this.functionStartDateRaw) {
        date.readable = moment(this.functionStartDateRaw).format("D-M-YYYY");
        date.formatted = moment(this.functionStartDateRaw).format("YYYY/MM/DD");
        date.firebase = new Date(
          moment(this.functionStartDateRaw).format("YYYY/MM/DD"),
        );
        return date;
      } else {
        return date;
      }
    },
    functionEndDate() {
      let date = {
        readable: "",
        formatted: "",
        firebase: null,
      };
      if (this.functionEndDateRaw) {
        date.readable = moment(this.functionEndDateRaw).format("D-M-YYYY");
        date.formatted = moment(this.functionEndDateRaw).format("YYYY/MM/DD");
        date.firebase = new Date(
          moment(this.functionEndDateRaw).format("YYYY/MM/DD"),
        );
        return date;
      } else {
        return date;
      }
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>
